import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { FileId, FileStatus } from '../../../shared/domain/files/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/files/multipartUpload/complete' }

type Params = never

export type Body = {
    uploadId: string
    fileId: FileId
    eTags: string[]
}

type Query = {
    shouldTranscode?: boolean
}

export type Output = {
    thumbnailUrl: string
    fetchUrl: string
    status: FileStatus
}

export type CompleteMultipartUploadEndpoint = Endpoint<Params, Body, Query, Output>

export const completeMultipartUploadRequest = (request: Request, args: RequestArgs<CompleteMultipartUploadEndpoint>) =>
    request<CompleteMultipartUploadEndpoint>(route, args)
